import TranslationService from "ceres/app/services/TranslationService";

function disableForm(form, disabled)
{
    Array.prototype.slice.call(
        form.querySelectorAll("input, select, textarea, button")
    ).forEach(input => input.disabled = disabled);
}
$(function ()
{
    $("#contact-modal__send").click(function(ev)
    {
        console.log("send2");
        ev.preventDefault();

        $(".has-error").removeClass("has-error");

        var isAllFilled = true;

        $.each($("#contact-modal-wrapper .input-unit [required], #contact-modal-wrapper input[type='checkbox'][required]"), function(index, item)
        {
            if ($(item).val() == "" && $(item).attr("type") != "checkbox")
            {
                $(item).addClass("has-error");
                isAllFilled = false;
            }
            else if ($(item).attr("type") == "checkbox" && $(item).prop("checked") == false)
            {
                $(item).closest(".form-check").find("label").addClass("has-error");
                isAllFilled = false;
            }
        });

        if (isAllFilled)
        {
            const mailObj =
                {
                    name: $("#contact-modal-wrapper [name=\"name\"]").val(),
                    message: $("#contact-modal-wrapper [name=\"message\"]").val(),
                    userMail: $("#contact-modal-wrapper [name=\"email\"]").val(),
                    subject: $("#contact-modal-wrapper [name=\"subject\"]").val(),
                    orderId: $("#contact-modal-wrapper [name=\"order\"]").val(),
                    itemId: $("#contact-modal-wrapper [name=\"itemid\"]").val(),
                    type: "contact"
                };

            $.ajax({
                url: "https://www.weberbuero.de/rest/weberbuero/customer/contact/mail",
                type: "POST",
                async: true,
                data: {
                    contactData: mailObj,
                    template: "Weberbuero::Customer.Components.Contact.ContactMail",
                    type: "contact"
                },
                success: function(data, textStatus, jqXHR)
                {
                    // success
                    $("#contact").modal("hide");

                    NotificationService.success(
                        TranslationService.translate("Weberbuero::Template.contactSendSuccess")
                    ).closeAfter(10000);
                },
                error: function(data)
                {
                }
            });

        }
    });

    console.log($(".contact-wrapper__content-form-send"))
    $(".contact-wrapper__content-form-send").click(function(ev)
    {

        console.log("send");
        // send form
        disableForm($(".contact-wrapper__content-form form")[0], true);
        ev.preventDefault();

        let sel = ".contact-wrapper__content-form";

        $(".contact-wrapper__content-form .has-error").removeClass("has-error");

        var isAllFilled = true;

        $.each($(sel + " .input-unit [required], " + sel + " .form-check [required]"), function(index, item)
        {
            if ($(item).attr("type") == "checkbox")
            {
                if (!$(item).prop("checked"))
                {
                    isAllFilled = false;
                    $(item).closest(".form-check").addClass("has-error");
                }
            }
            else
            {
                if ($(item).val() == "")
                {
                    $(item).closest(".input-unit").addClass("has-error");
                    isAllFilled = false;
                }
            }
        });

        var $gtc = $("#contact-wrapper__privacy-policy-accept");

        if ($gtc.prop("checked") === false)
        {
            isAllFilled = false;
        }

        if (isAllFilled)
        {

            const mailObj =
                {
                    email: $("#contact-wrapper__mail").val(),
                    name: $("#contact-wrapper__txt_name").val(),
                    order: $("#contact-wrapper__txt_order").val(),
                    message: $("#contact-wrapper__txt_message").val(),
                    userMail: $("#contact-wrapper__mail").val(),
                    subject: $("#contact-wrapper__txt_subject").val(),
                    cc: $("#contact-wrapper__copy_to_me").prop("checked"),
                    type: "contactwrapper"
                };

            $.ajax({
                url: "https://www.weberbuero.de/rest/weberbuero/customer/contact/mail",
                type: "POST",
                async: true,
                data: {
                    contactData: mailObj,
                    template: "Weberbuero::Customer.Components.Contact.ContactWrapperMail",
                    type: "contactwrapper"
                },
                success: function(data, textStatus, jqXHR)
                {
                    console.log("success");
                    $(".contact-wrapper__content-form form")[0].reset();
                    disableForm($(".contact-wrapper__content-form form")[0], false);

                    // success
                    NotificationService.success(
                        TranslationService.translate("Weberbuero::Template.contactSendSuccess")
                    ).closeAfter(10000);

                    $(".contact-wrapper").removeClass("is-open");
                    $(".etrusted-badge-container").removeClass("less-index");
                },
                error: function(data)
                {
                    console.log("error");
                                        disableForm($(".contact-wrapper__content-form form")[0], false);

                }
            });

        }
        else
        {
            disableForm($(".contact-wrapper__content-form form")[0], false);
        }
    });
})
